import React from 'react';
import { observer } from 'mobx-react';
import { MembershipTypeStore } from '@seedlang/stores';
import Cookies from 'js-cookie';
import Alert from 'components/alert';
import { observable } from 'mobx';
import { Link } from 'react-router';
import { AppUI } from '@seedlang/state';
import CreateWithTitle from 'components/creator/create_with_title';

@observer
class MembershipTypeCreate extends React.Component {
  @observable showMailingMessage = false;

  onCreate = name => {
    MembershipTypeStore.create(
      {
        data: {
          name,
          site_id: Cookies.get('site_id'),
        },
      },
      this.afterCreateMembershipType,
    );
  };

  afterCreateMembershipType = () => {
    MembershipTypeStore.getIndex();
    this.showMailingMessage = true;
  };

  render() {
    return (
      <div className='membership-type-create row'>
        {
          this.showMailingMessage &&
            <Alert width='100%'>
              {
                AppUI.routeStore?.router?.params?.groupId &&
                <Link
                  target='_blank'
                  to={{
                    name: 'creator.campaign_types.index',
                    params: {groupId: AppUI.routeStore?.router?.params?.groupId},
                  }}
                >
                  Don't forget to create a new "Registration" mailing campaign for people who sign up to this new membership type.
                </Link>
              }
              {!AppUI.routeStore?.router?.params?.groupId && 'Don\'t forget to create a new "Registration" mailing campaign for people who sign up to this new membership type.'}
            </Alert>
        }
        <CreateWithTitle
          placeholder='Add a name'
          onCreate={this.onCreate}
        />
      </div>
    );
  }
}

export default MembershipTypeCreate;
